export default "__VITE_ASSET__C2EMx2w6__"